"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const updateEnrolmentFields_1 = require("./updateEnrolmentFields");
function deassignEnrolment(command, content, enrolment) {
    try {
        return immer_1.default(enrolment, (draftEnrolment) => {
            updateEnrolmentFields_1.updateParentIds(command, content, draftEnrolment);
            // if deassigned via course
            if (command.rootContentId === draftEnrolment.contentId) {
                if (draftEnrolment.direct === true) {
                    updateEnrolmentFields_1.updateDirectEnrolment(command, draftEnrolment);
                }
                else if ((draftEnrolment.parentIds || []).length > 0) {
                    throw new Error('Course cannot be unassigned, Part of Curriculum(s)');
                }
            }
            updateEnrolmentFields_1.updateDeletedInEnrolment(command, draftEnrolment);
            if (draftEnrolment !== enrolment) {
                draftEnrolment.updatedAt = command.timeStamp;
            }
        });
    }
    catch (error) {
        throw new Error('Error in deassignEnrolment ' + error);
    }
}
exports.default = deassignEnrolment;
//# sourceMappingURL=deassignEnrolment.js.map